import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import PropTypes from 'prop-types';

const Team = props => {

    const { name, slug, urlAssets, urlEspecial, queryStrStart, queryStrParam } = props;
    const urlTeam = (slug !== '') ? `${urlEspecial}${queryStrStart}${queryStrParam}=${slug}` : '';
    const shieldTeam = (slug !== '') ? slug : 'cupo';
    
    return (
        <article className="col-6 col-md-4 text-center py-3">
            <div className="d-flex align-items-center justify-content-center px-3 px-md-0 cont-shield">
                <a href={urlTeam}>
                    <LazyLoadImage
                        alt={name}
                        className="img-fluid"
                        effect="blur"
                        src={`${urlAssets}/img/selecciones-portada/${shieldTeam}.png`}
                    />
                </a>
            </div>
            <div className="mt-1 mx-md-5">
                <a className="w-100 btn border border-white shadow-sm btn-team" href={urlTeam}>{name}</a>
            </div>
        </article>
    )
}

export default Team;

Team.propTypes = {
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    urlAssets: PropTypes.string.isRequired,
    urlEspecial: PropTypes.string.isRequired, 
    queryStrStart: PropTypes.string.isRequired, 
    queryStrParam: PropTypes.string.isRequired
}